/* eslint-disable react/jsx-one-expression-per-line */
import styled from 'styled-components';
import { useRouter } from 'next/router';
import H2 from '@base/H2/H2';
import P1 from '@base/P1/P1';
import H3 from '@base/H3/H3';
import ContentsTable from '@base/ContentsTable/ContentsTable';
import MenusNav from '@base/MenusNav/MenusNav';
import { menus } from '@utils/constants';
import { Spacings } from '@styles/index';

const Left = styled.div`
  grid-column: 1/6;
  position: fixed;
  @media (max-width: 768px) {
    display: none;
  }
`;

const Right = styled.div`
  grid-column: 6/25;
  @media (max-width: 768px) {
    grid-column: 1/25;
    margin-left: ${Spacings.SPACING_4B};
    margin-right: ${Spacings.SPACING_4B};
  }
`;

const LegalNoticesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: span 24;
`;

const LegalNoticesContainer = styled.div``;

const StyledH3 = styled(H3)`
  margin-bottom: ${Spacings.SPACING_6B};
  padding-top: 100px;
  margin-top: -100px;
`;

const H2Container = styled.div``;

const tableData = [
  { label: '1. Copyright', id: 'copyright' },
  { label: '2. Trademark', id: 'trademark' },
  { label: '3. Other legal notices', id: 'other' }
];

const LegalNotices = () => {
  const router = useRouter();
  const { pathname } = router;

  return (
    <>
      <Left>
        <MenusNav data={menus} currentHref={pathname} />
      </Left>

      <Right>
        <LegalNoticesWrapper>
          <LegalNoticesContainer>
            <H2Container>
              <H2>Legal Notices</H2>
            </H2Container>
            <br />
            <br />
            <ContentsTable data={tableData} />

            <a name="copyright">
              <StyledH3>1. Copyright</StyledH3>
            </a>
            <P1>
              The copyright in the User Content on Unacademy Platform are owned
              by educators, where Unacademy is a limited license holder to
              publish the same on Unacademy Platform. The User Content is
              subject to the various Terms and Conditions and other policies
              (together “Terms”) as provided on the Unacademy Platform, kindly
              ensure that you use the User Content only within the parameters as
              provided in the Terms. You are prohibited from using the User
              Content as your own without the prior permission of the content
              creator and Unacademy.
            </P1>
            <P1>
              Unacademy Content on the Unacademy Platform including but not
              limited to, images, graphics, process, images, software, graphics,
              are owned by or licensed to Unacademy and subject to Copyright and
              you are prohibited from using the same as your own, without the
              prior permission of Unacademy. For clarity, Unacademy Content does
              not include User Content.
            </P1>
            <P1>
              If you believe that any Educator/User has used copyright-protected
              work in the User Content posted on the Unacademy Platform, an
              option to report the User Content is provided and you can report
              the same by using the report button or if you believe your or
              someone else’s copyrights are being infringed upon through the
              Unacademy Platform, then let us know by writing to us at{' '}
              <a href="mailto:legal@unacademy.com">legal@unacademy.com</a>.
            </P1>
            <P1>
              Please note that by claiming copyright infringement you are
              initiating a legal process, kindly be sure to consider whether
              fair use, fair dealing, or a similar exception to copyright apply
              before you report.
            </P1>
            <br />
            <br />

            <a name="trademark">
              <StyledH3>2. Trademark</StyledH3>
            </a>
            <P1>
              The trademarks, service marks, logos displayed on the Unacademy
              Platform are owned by Unacademy (“Unacademy Marks”). If you
              haven’t received our permission, do not use the Unacademy Marks as
              your own or in any manner that implies sponsorship or endorsement
              or any relation to Unacademy.
            </P1>
            <P1>
              A product or service branded with the Unacademy name or logo is a
              reflection of Unacademy. Unless you are one of our licensees, we
              don’t allow others to make, sell, or give away anything with our
              name or logo on it.
            </P1>
            <br />
            <br />

            <a name="other">
              <StyledH3>3. Other legal notices</StyledH3>
            </a>
            <P1>
              In the event of any other disputes or claims arising from the use
              of the Unacademy Platform, please get in touch with us at{' '}
              <a href="mailto:legal@unacademy.com">legal@unacademy.com</a>.
            </P1>
            <br />
            <br />
          </LegalNoticesContainer>
        </LegalNoticesWrapper>
      </Right>
    </>
  );
};

LegalNotices.pageInfo = {
  name: 'Legal Notices',
  layoutOptions: {
    hideGoalSelector: true,
    disableDarkMode: true
  }
};

export default LegalNotices;
